<template>
  <div class="content">
    <div class="col-md-8 flex-container-top">
      <h2 class="text-eveer">Pending Vaccination Confirmations</h2>
    </div>

    <div class="row">
      <div class="col-md-3" v-for="user in users" v-bind:key="user._id">
       <img class="rest-img" :src="user.vaccine_proof_img" alt="..." />
        <card class="card-user">
          <p class="card-text"></p>
          <div class="author">
            <a href="javascript:void(0)">
              <h5 class="title">{{user.first_name}} {{user.last_name}}</h5>
            </a>
          </div>
          <p></p>

          <div slot="footer">
            <div class="row" style="display: flex; justify-content: space-evenly">
              <button
                class="btn btn-fill"
                @click="approve(user._id)"
                style="color: lightgreen"
              >
                <i class="fa fa-check-circle"></i> Confirm
              </button>
              <button
                class="btn btn-fill"
                @click="reject(user._id)"
                style="color: red"
              >
                <i class="fa fa-times-circle"></i> Reject
              </button>
            </div>
          </div>

        </card>
      </div>
    </div>

    <div class="row loader-pos">
      <div class="sk-chase" v-if="loading">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>

      <div class="no-data-message" v-if="noDataMessage">
        <div>There are no vaccination approvals pending</div>
      </div>
    </div>

  </div>
</template>
<script>
import { Modal, BaseAlert } from "src/components";

export default {
  data() {
    return {
      users: [],
      images: [],
      loading: true,
      noDataMessage: false,
    };
  },
  components: {
    Modal,
    BaseAlert,
  },
  methods: {
    filterUserList(userList) {
    userList = userList.filter(user => user.vaccinated != true);
    userList = userList.filter(user => (user.vaccine_proof_img != "" && user.vaccine_proof_img != null));
    return userList
  },
    async getVaccinePhotos(userList) {
    for(let user of userList) {
      user.vaccine_proof_img = await this.$apiService.getVaccineImage(user.vaccine_proof_img);
    }
  },
    async approve(user_id) {
      console.log("updating user vaccination status");
      console.log(user_id);
      let newVaccinationStatus = {};
      newVaccinationStatus.id = user_id;
      newVaccinationStatus.vaccinated = true;

      let updateReponse = await this.$apiService.postCall(
        "user/set-vaccine-status",
        newVaccinationStatus
      );

      if (!updateReponse.isError) {
        let apiResponse = await this.$apiService.getCall("user/all-users");
        this.users = apiResponse.apidata.Data;
        this.users = this.filterUserList(this.users);

        this.loading = false;
        if ((this.users || []).length == 0) {
          this.noDataMessage = true;
        }
      }
    },
    async reject(user_id) {
      console.log("updating user vaccination status");
      let newVaccinationStatus = {};
      newVaccinationStatus.id = user_id;
      newVaccinationStatus.vaccinated = false;

      let updateReponse = await this.$apiService.postCall(
        "user/set-vaccine-status",
        newVaccinationStatus
      );

      if (!updateReponse.isError) {
        let apiResponse = await this.$apiService.getCall("user/all-users");
        this.users = apiResponse.apidata.Data;
        this.users = this.filterUserList(this.users);
        this.loading = false;
        if ((this.users || []).length == 0) {
          this.noDataMessage = true;
        }
      }
    }
  },
  async mounted() {
    this.loading = true;
    let apiResponse = await this.$apiService.getCall("user/all-users");

    this.users = apiResponse.apidata.Data;
    this.users = this.filterUserList(this.users);
    await this.getVaccinePhotos(this.users);

    this.loading = false;
    if ((this.users || []).length == 0) {
      this.noDataMessage = true;
    }
  }
};
</script>
